import { Component, OnInit, output, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-overlay-message.content.json';

@Component({
    selector: 'conversational-chat-overlay-message',
    templateUrl: './conversational-chat-overlay-message.component.html',
    standalone: false
})
export class ConversationalChatOverlayMessageComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    public selectContinueConversation = output<void>();

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public setContinueConversation(): void {
        this.selectContinueConversation.emit();
    }
}
